<template>
  <van-action-sheet class="select-tag" v-model="visible" :title="titleStr" @close="close" :close-on-click-overlay="false" get-container="#page">
        <div class="select-tag-cont">
            <van-tree-select
            height="50vh"
            :items="list"
            :main-active-index.sync="ind"
            @click-nav="clickClass"
            selected-icon="success"
        >
            <template #content>
                <van-checkbox-group v-model="itemInds" @change="changeOffice" :max="1">
                    <van-cell-group>
                        <van-cell
                            v-for="(item, index) in children"
                            :key="index"
                            :title="item.name"
                            :clickable="!disabled && index == itemInds[0]"
                            :disabled="disabled && index !== itemInds[0]"
                            @click="toggle(index)"
                        >
                            <template #right-icon>
                                <!-- <van-radio :name="index" ref="checkboxes" checked-color="#D3172E" :disabled="disabled"/> -->
                                <van-checkbox :name="index" checked-color="#D3172E" ref="checkboxes" :disabled="disabled && index !== itemInds[0]"></van-checkbox>
                            </template>
                        </van-cell>
                    </van-cell-group>
                </van-checkbox-group>
            </template>
        </van-tree-select>
        </div>
        <div class="select-tag-confirm">
            <van-cell class="select-tag-confirm-cell">
                <template slot="title">
                    <div class="select-tag-confirm-left">已选：</div>
                    <div class="select-tag-confirm-content">{{ checkedStr }}</div>
                    <van-icon v-if="checkedStr" name="close" @click="btnClear()"/>
                    <van-button
                        class="select-tag-confirm-btn"
                        type="danger"
                        @click="choose()"
                        color="#D3172E"
                        round
                        size="small"
                        >确定</van-button
                    >
                </template>
            </van-cell>
        </div>
  </van-action-sheet>
</template>

<script>
import Interface from '@/util/interface'
export default {
    name: 'selectTag',
    props: {
        type: {
            type: String,
            default: '1'
        },
        show: {
            type: Boolean,
            required: true,
            default: false
        },
        disease: {
            type: Array,
            required: true,
            default: []
        },
        values: {
            type: String,
            required: true,
            default: ''
        },
    },
    watch: {
        show: {
            handler(val) {
                this.visible = val
                if(val) {
                    this.init()
                }
            },
            immediate: true
        },
        disease: {
            handler(val) {
                if(!val.length) {
                    this.allData = []
                    return
                }
                this.allData = JSON.parse(JSON.stringify(val))
                this.init()
            },
            immediate: true,
            deep: true
        },
        values: {
            handler(val) {
                this.initValues = val ? val.split(',') : []
                this.init()
            },
            immediate: true,
        },

    },
    data() {
        return {
            visible: false,
            // formData: {},
            index: '',
            ind: 0,
            itemInd: '',
            itemInds: [],
            allData: [],
            checked: {},
            max: 3,
            pId: '',
            loading: false,
            initValues: []
        }
    },
    computed: {
        disabled() {
            let flag = Object.keys(this.checked).length >= this.max ? true : false
            return flag
        },
        checkedStr() {
            let str = Object.values(this.checked).map(item => {return item.name}).join(",")
            return str;
        },
        titleStr() {
            let typeDict = {
                '1': '确诊疾病',
                '2': '经历的治疗方式'
            }
            return `请选择${typeDict[this.type]}`
        },
        list() {
            // let typeDict = {
            //     '1': 'confirmed_disease',
            //     '2': 'experience_treatment'
            // }
            // if(!this.type || !Object.keys(this.allData).length) return []
            // let list = this.allData[typeDict[this.type]]

            if(!this.allData) return []
            // let data = this.allData
            this.allData = this.allData.map(item => {
                item.text = item.name
                if(!item.children) {
                    item.children = [{
                        name: item.name,
                        id: item.id,
                        parent_id: item.id,
                    }]
                } else {
                    item.children = item.children.map(c => {
                        c.parent_id = item.id
                        c.children = null
                        return c
                    })
                }
                return item
            })
            // return this.allData[typeDict[this.type]]
            return this.allData
        },
        children() {
            if(!this.list.length || this.ind === '') return []
            return this.list[this.ind].children
        }
    },
    methods: {
        // disabled(ind) {
        //     console.log('this.itemInd:', this.itemInd, this.itemInd !== ind, ind)
        //     let flag = Object.keys(this.checked).length >= this.max && this.itemInd !== ind ? true : false
        //     return flag
        // },
        close() {
            this.$emit('update:show',false)
        },
        btnClear() {
            this.checked = {}
            this.itemInd = ''
            this.itemInds = []
        },
        toggle(index) {
            if(this.disabled && index !== this.itemInds[0]) return;
            this.$refs.checkboxes[index].toggle();
        },
        changeOffice(val) {
            let pId =  this.list[this.ind].id.toString()
            if(!val.length) {
                if(Object.keys(this.checked).includes(pId)) {
                    this.$delete(this.checked, pId)
                }
                return
            }
            if(Object.keys(this.checked).length >= this.max) {
                this.$toast.fail(`最多选择${this.max}个`)
                return
            }
            
            this.index = val[0]
            this.$set(this.checked, pId, {
                name: this.children[this.index].name,
                id: this.children[this.index].id
            })
        },
        clickClass(val) {
            if(Object.keys(this.checked).length >= this.max) {
                this.$toast.fail(`最多选择${this.max}个`)
                // return
            }
            let id = this.list[val].id.toString(),
            isChecked = Object.keys(this.checked).includes(id)
            if(isChecked) {
                this.itemInd = this.children.findIndex(item => item.id == this.checked[id].id)
                this.itemInds = [this.itemInd]
            } else {
                this.itemInd = ''
                this.itemInds = []
            }
        },
        choose() {
            // let result = {
            //     id: this.list[this.ind].id,
            //     name: this.list[this.ind].name,
            //     cId: this.children[this.itemInd].id,
            //     cName: this.children[this.itemInd].name
            // }
            let result = Object.values(this.checked)
            this.$emit('update:show',false)
            this.$emit('chooseTag', result)
            
        },
        init() {
                if(!this.list.length) {
                    this.pId = ''
                    this.ind = 0
                    this.itemInd = ''
                    this.itemInds = []
                    this.index = ''
                    return
                }
                let result = []
                this.checked = {}
                this.list.forEach(ele => {
                    if (ele.children && ele.children.length > 0) {
                        result.push(...ele.children)
                    }
                    
                });
                result.forEach(it => {
                    if(this.initValues.includes(it.id.toString())) {
                        this.$set(this.checked, it.parent_id, it)
                    }
                })
                
                let keys = Object.keys(this.checked)
                if(!keys.length) return
                this.pId = keys[0]
                this.ind = this.list.findIndex(item => item.id == this.pId)
                this.itemInd = this.children.findIndex(item => item.id == this.checked[this.pId].id)
                this.index = this.itemInd
                this.itemInds = [this.itemInd]
            },
    },
    created() {
        // this.formData = JSON.parse(localStorage.getItem('add-info'))
    }
}
</script>

<style scoped lang="scss">
// @import "@/components/variable.scss";
// @import "@/components/search.scss";

.select-tag {

    // position: relative;
    &-cont{
        margin-top: 4px;
        margin-bottom: 79px;
        min-height: 300px;
    }
    &-confirm{
        position: fixed;
        bottom: 0;
        width: 100%;
        border: 0px solid #ebedf0;
        border-width: 1px 0;
        &-cell{
            height: 70px;
        }

        &-left{
            width: 42px;
            float: left;
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #404040;
        }
        &-content{
            width: 180px;
            float: left;
            font-family: PingFangSC-Medium;
            font-size: 15px;
            color: #404040;
            letter-spacing: 0;
        }

        &-btn{
            float: right;
            background: #D3172E;
            border-radius: 20px;
            width: 100px;
            height: 40px;
            //margin-top: -10px;
        }
    }

}
</style>


// WEBPACK FOOTER //
// src/views/login/add-info/components/selectTagNew.vue